(function () {
  var root = document.getElementById('fp-root');
  if (!root || root.dataset.fpInit) return;
  root.dataset.fpInit = '1';

  var CFG = JSON.parse(document.getElementById('fp-config').textContent);
  var KLAVIYO_KEY = CFG.klaviyo_key;
  var KLAVIYO_LIST = CFG.klaviyo_list_id;
  var KLAVIYO_REV  = CFG.klaviyo_revision;
  var SMS_ON = CFG.sms_subscribe;
  var DROP_ISO = CFG.drop_datetime;

  var COPY = {
    teaser: {
      eyebrow: 'Drop ' + CFG.drop_number + ' \u00b7 Price sealed',
      headline: 'We can show you the bottle. Not the price.',
      sub: 'A limited quantity of ' + CFG.bottle_name + ' goes on sale Friday at twelve noon, at a number our distributors won\u2019t let us publish a minute sooner.',
      cta: 'Get notified',
      ctaNote: 'One message on Friday, with the price and the link.',
      clockLabel: 'The price unseals in',
      tagTop: CFG.drop_number, tagBottom: 'Sealed',
      scarce: 'Limited quantities \u00b7 one allocation, no restock'
    },
    live: {
      eyebrow: 'Drop ' + CFG.drop_number + ' \u00b7 Open now',
      headline: CFG.bottle_name + ', ' + CFG.drop_price + '.',
      sub: CFG.bottle_copy_short || ('A limited quantity at ' + CFG.saving + ' under retail, shipping within ' + CFG.ship_within + '.'),
      cta: 'Add to cart',
      ctaNote: 'The price closes with the allocation. There is no restock.',
      clockLabel: '',
      tagTop: CFG.saving, tagBottom: 'Under retail',
      scarce: 'Limited quantities available'
    },
    low: {
      eyebrow: 'Drop ' + CFG.drop_number + ' \u00b7 Final bottles',
      headline: 'Down to the last bottles.',
      sub: CFG.bottle_name + ' at ' + CFG.drop_price + '. At the current pace this closes inside the hour, and Drop ' + CFG.drop_number + ' does not come back at any price.',
      cta: 'Add to cart',
      ctaNote: 'Checkout holds your bottle for eight minutes.',
      clockLabel: '',
      tagTop: CFG.saving, tagBottom: 'Under retail',
      scarce: 'Very limited stock remaining'
    },
    soldout: {
      eyebrow: 'Drop ' + CFG.drop_number + ' \u00b7 Closed',
      headline: 'Gone in ' + CFG.recap_minutes + '.',
      sub: 'Drop ' + CFG.drop_number + ' is fully allocated. The next drop is already secured and opens Friday at twelve noon.',
      cta: 'Join the waitlist',
      ctaNote: 'We notify the whole list together when the next price unseals.',
      clockLabel: 'The next drop unseals in',
      tagTop: CFG.drop_number, tagBottom: 'Allocated',
      scarce: 'Fully allocated'
    },
    recap: {
      eyebrow: 'Drop ' + CFG.drop_number + ' \u00b7 Recap',
      headline: 'What the allocation looked like.',
      sub: CFG.bottle_name + ', ' + CFG.retail_price + ' at retail, released at ' + CFG.drop_price + '. It closed in ' + CFG.recap_minutes + ' with ' + CFG.recap_queue + ' people still in line behind it.',
      cta: 'Get notified',
      ctaNote: 'One message on Friday. Nothing else.',
      clockLabel: 'The next drop unseals in',
      tagTop: CFG.recap_minutes, tagBottom: 'To sell out',
      scarce: 'Limited quantities \u00b7 one allocation, no restock'
    }
  };

  var VALID = ['teaser', 'live', 'low', 'soldout', 'recap'];
  try {
    var q = new URLSearchParams(location.search).get('state');
    if (q && VALID.indexOf(q) >= 0) root.dataset.state = q;
  } catch (e) {}
  var state = root.dataset.state || 'live';
  if (VALID.indexOf(state) < 0) state = 'live';
  var copy = COPY[state] || COPY.live;

  function put(key, val) {
    root.querySelectorAll('[data-fp="' + key + '"]').forEach(function (el) { el.textContent = val; });
  }
  put('eyebrow', copy.eyebrow);
  put('headline', copy.headline);
  put('sub', copy.sub);
  put('cta', copy.cta);
  put('ctaNote', copy.ctaNote);
  put('clockLabel', copy.clockLabel);
  put('tagTop', copy.tagTop);
  put('tagBottom', copy.tagBottom);

  put('scarce', copy.scarce);

  /* ---- countdown ---- */
  function nextDrop() {
    if (DROP_ISO) {
      var t = Date.parse(DROP_ISO);
      if (!isNaN(t) && t > Date.now()) return t;
    }
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + ((5 - d.getDay() + 7) % 7));
    if (d.getTime() <= Date.now()) d.setDate(d.getDate() + 7);
    return d.getTime();
  }
  var target = nextDrop();
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick() {
    var ms = Math.max(0, target - Date.now());
    var dd = Math.floor(ms / 86400000);
    var hh = Math.floor((ms % 86400000) / 3600000);
    var mm = Math.floor((ms % 3600000) / 60000);
    var ss = Math.floor((ms % 60000) / 1000);
    put('cd-d', pad(dd)); put('cd-h', pad(hh)); put('cd-m', pad(mm)); put('cd-s', pad(ss));
    put('exitCopy', dd > 0 ? dd + ' days ' + hh + ' hours' : hh + ' hours ' + mm + ' minutes');
  }
  tick();
  setInterval(tick, 1000);

  /* ---- modals ---- */
  var lastFocus = null;
  function open(name) {
    var m = root.querySelector('[data-fp-modal="' + name + '"]');
    if (!m) return;
    lastFocus = document.activeElement;
    root.querySelectorAll('.fp-modal').forEach(function (x) { x.dataset.open = 'false'; });
    m.dataset.open = 'true';
    document.body.style.overflow = 'hidden';
    var f = m.querySelector('input');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeAll() {
    root.querySelectorAll('.fp-modal').forEach(function (x) { x.dataset.open = 'false'; });
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  root.querySelectorAll('[data-fp-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); open(b.dataset.fpOpen); });
  });
  root.querySelectorAll('[data-fp-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
  root.querySelectorAll('.fp-modal').forEach(function (m) {
    m.addEventListener('click', function (e) { if (e.target === m) closeAll(); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* primary CTA behaviour by state */
  var cta = root.querySelector('[data-fp-cta]');
  if (cta) {
    if (state === 'live' || state === 'low') {
      /* leave the real add-to-cart form submit intact */
    } else {
      var form = document.getElementById('fp-cart-form');
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        open(state === 'soldout' ? 'waitlist' : 'signup');
      });
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });
    }
  }

  /* entry pop-up + exit intent */
  if (CFG.auto_popup && state !== 'live' && state !== 'low') {
    setTimeout(function () {
      if (!root.querySelector('.fp-modal[data-open="true"]') && !sessionStorage.getItem('fp_seen')) {
        sessionStorage.setItem('fp_seen', '1');
        open('signup');
      }
    }, (parseInt(CFG.auto_popup_delay, 10) || 3) * 1000);
  }
  if (CFG.exit_popup && state !== 'live' && state !== 'low') {
    var exitShown = false;
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 0 && !exitShown && !root.querySelector('.fp-modal[data-open="true"]')) {
        exitShown = true;
        open('exit');
      }
    });
  }

  /* ---- Klaviyo ---- */
  function e164(raw) {
    if (!raw) return null;
    var d = String(raw).replace(/[^0-9+]/g, '');
    if (d.indexOf('+') === 0) return d.length >= 11 ? d : null;
    d = d.replace(/[^0-9]/g, '');
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return null;
  }

  function subscribe(email, phone, source) {
    var profile = { email: email };
    var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    var ph = e164(phone);
    if (ph) {
      profile.phone_number = ph;
      if (SMS_ON) subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    profile.properties = { 'Final Pour Source': source, 'Final Pour Drop': String(CFG.drop_number) };
    profile.subscriptions = subs;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Final Pour — ' + source,
          profile: { data: { type: 'profile', attributes: profile } }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_KEY), {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': KLAVIYO_REV },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status === 202 || r.ok) return true;
      return r.text().then(function (t) { throw new Error(t || ('HTTP ' + r.status)); });
    });
  }

  root.querySelectorAll('[data-fp-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = form.querySelector('[data-fp-msg]');
      var btn = form.querySelector('button[type="submit"]');
      var email = (form.querySelector('[name="email"]') || {}).value;
      var phone = (form.querySelector('[name="phone"]') || {}).value;

      if (!email || email.indexOf('@') < 1) {
        if (msg) { msg.dataset.tone = 'err'; msg.textContent = 'Enter a valid email address.'; }
        return;
      }
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Sending…'; }
      if (msg) { msg.dataset.tone = ''; msg.textContent = ''; }

      subscribe(email.trim(), phone, form.dataset.fpForm)
        .then(function () {
          if (msg) { msg.dataset.tone = 'ok'; msg.textContent = 'You’re on the list. Watch for Friday at noon.'; }
          form.reset();
          if (window.klaviyo && window.klaviyo.push) {
            window.klaviyo.push(['track', 'Final Pour Signup', { source: form.dataset.fpForm, drop: CFG.drop_number }]);
          }
          setTimeout(function () { if (form.closest('.fp-modal')) closeAll(); }, 1600);
        })
        .catch(function (err) {
          if (msg) { msg.dataset.tone = 'err'; msg.textContent = 'Something went wrong. Please try again.'; }
          if (window.console) console.error('[Final Pour] Klaviyo subscribe failed:', err);
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Notify me'; }
        });
    });
  });
})();
